export function checkboxToIds(value: any, defaultValue: any = []) {
  if (!value || !Object.keys(value).length) {
    return defaultValue;
  }
  return Object.keys(value).reduce((n: any, k: any) => {
    if (value[k]) {
      n.push(k);
    }
    return n;
  }, []);
}
